import { Component, computed, inject, OnInit, output, Signal } from '@angular/core';
import { SignupV2Service } from '../../signup-v2.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { handleImageError, handleImageError2 } from '../../../../shared/common/utils';
import { formatDateToReadableString } from '../../../../shared/utils/formatting';
import { ModalContentService } from '../../../../shared/modal-content/modal-content.service';
import { ModalContentTypes } from '../../../../shared/constants/modal-content-types';
import { ModalContentData } from '../../../../shared/modal-content/modal-content';
import { Frequencies } from '../../../../shared/types/common.types';
import { LoaderSizeEnum } from '../../../../shared/section-loader/section-loader.types';
import { SectionLoaderComponent } from '../../../../shared/section-loader/section-loader.component';

@Component({
  selector: 'app-produce-box-step',
  imports: [CommonModule, FormsModule, SectionLoaderComponent],
  templateUrl: './produce-box-step.component.html',
  styleUrl: './produce-box-step.component.scss'
})
export class ProduceBoxStepComponent implements OnInit {

  svc = inject(SignupV2Service);
  private modalService = inject(ModalContentService);

  // Output para comunicarse con el componente padre
  stepCompleted = output<void>();

  // Frequency-related properties
  frequencies = computed(() => this.svc.getFrequencies());

  isProduceBoxesLoading: Signal<boolean> = computed(() => this.svc.getIsProduceBoxesLoading());

  LoaderSizeEnum = LoaderSizeEnum;

  ngOnInit() { 
    this.svc.loadProduceBoxesIfNeeded();
    this.svc.loadFrequenciesIfNeeded();
  }

  customizable = computed(() => this.svc.getProduceBoxes().filter(b => b._signup?.group === 'customizable'));
  nonCustomizable = computed(() => this.svc.getProduceBoxes().filter(b => b._signup?.group === 'non-customizable'));
  selectedIds = computed(() => this.svc.getSelectedProduceBoxIds());

  toggle(id: number) { 
    this.svc.toggleProduceBox(id);
    // Initialize frequency selection for newly selected boxes
    if (this.isActive(id) && !this.svc.getProduceBoxFrequency(id)) {
      this.initializeFrequencyForBox(id);
    }
  }
  isActive(id: number) { return this.selectedIds().includes(id); }

  // Frequency management methods
  initializeFrequencyForBox(boxId: number) {
    const frequencies = this.frequencies();
    if (frequencies.length > 0) {
      this.svc.setProduceBoxFrequency(boxId, frequencies[0]);
    }
  }

  onFrequencyChange(boxId: number, frequencyId: number) {
    const frequencies = this.frequencies();
    const selectedFrequency = frequencies.find(f => f.id === +frequencyId);
    if (selectedFrequency) {
      this.svc.setProduceBoxFrequency(boxId, selectedFrequency);
    }
  }

  getSelectedFrequency(boxId: number): Frequencies | null {
    return this.svc.getProduceBoxFrequency(boxId);
  }


  onImageError = handleImageError2;

  openModalWhatsInside(event: MouseEvent, product: any) {
    event.stopPropagation();
    if (!product?.bundle?.isPublished) return;
    const startDate = formatDateToReadableString(product.bundle.startDate).mmddyyyyFormat;
    const endDate = formatDateToReadableString(product.bundle.endDate).mmddyyyyFormat;
    this.modalService.openModal(ModalContentTypes.BOX_DETAIL, {
      title: product.name,
      fullScreenOnMobile: true,
      boxDetail: {
        isSubscription: true,
        existsInOrder: false,
        startDate,
        endDate,
        publishedBundles: product?.bundle?.publishedBundles,
        detail: product?.bundle?.items?.map((e: any) => {
          return {
            img: e.img,
            productName: e.name,
            quantity: e.quantity,
            packageName: e.packageName || e.display || '',
            producer: e.producerName || '',
            price: e.price,
          }
        })
      }
    } as ModalContentData).closed.subscribe(
      (res: { addToCart: boolean }) => {
        if (res.addToCart) {
          this.toggle(product.id);
        }
      }
    )
  }

  async onNext() {
    if (!this.svc.canProceed('produce')) return;
    const isCompleted = await this.svc.markCompleted('produce');
    if (isCompleted) {
      this.stepCompleted.emit();
    }
  }
}
